import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button.vue"
import gDataTable from "@/components/g-data-table/g-data-table.vue"
import ClienteController from "@/shared/controllers/cliente/clienteController";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import FiltroDevolucoes from "@/shared/view-models/Filtros/FiltroDevolucoes";
import ProdutoController from "@/shared/controllers/produto/produtoController";
import DevolucoesController from "@/shared/controllers/consultas/DevolucoesController";
import { defineComponent } from "vue";

export default defineComponent({
  name:'ConsultasDevolucoes',
  setup() {
  },
  components:{
    'g-card': gCard,
    'g-form': gForm,
    'g-button': gButton,
    'g-data-table': gDataTable,
  },

  props: { },

  validations() {

  },

  mounted(){
    // this.getClientes(),
    this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId;
    this.UnidadeArray = EmpresaController.getEmpresasAtivas().EmpresaArray;

    this.GetStatusDevolucoes()

    // this.situacaoArray = DevolucoesController.GetStatusDevolucoes()
    
    this.popularDropDownEmpresa();
    this.mitt.on('trocaEmpresaRepresentante', () => {
      this.atualizaEmpresaRepresentante()
    })
  },

  updated () { },

  data(){
    return{
      pt1: true,
      ClientesArray: [],
      EmpresaArray: [],
      UnidadeArray: [],
      devolucoesArray: [],
      ProdutoArray: [],
      array: [],
      situacaoArray: [
        {label: 'Todas', value: null},
      ],
      StatusArray: [],
      timer: null,
      formSearch: new FiltroDevolucoes(),
      Colunas : [
        //Campo dos dados , nome que aparece na página
        {field: 'numeroAutorizacao', header: 'Autorização'},
        {field: 'codigoExternoPedido', header: 'Pedido/Parcela'},
        {field: 'documentoOrigem', header: 'Doc. Origem'},
        {field: 'dataRecebimentoFormatada', header: 'Recebimento'},
        {field: 'nomeProduto', header: 'Produto', width: '350px'},
        {field: 'quantidadeCaixasFormatada', header: 'Qtde Caixas', alinha: 'right'},
        {field: 'status', header: 'Status'},
        {field: 'diasEmEstoque', header: 'Dias em Estoque', alinha: 'right'},
        {field: 'motivoDevolucao', header: 'Motivo'},
      ],
      Filtro: {
        'global': {value: null, matchMode: this.filtros.CONTAINS}, //permite buscar por colunas específicas
        'autorizacao': {value: null, matchMode: this.filtros.CONTAINS},
        'cliente': {value: null, matchMode: this.filtros.CONTAINS},
        'documentoOrigem': {value: null, matchMode: this.filtros.CONTAINS},
        'dataRecebimentoFormatada': {value: null, matchMode: this.filtros.CONTAINS},
        'produto': {value: null, matchMode: this.filtros.CONTAINS},
        'qtdeCaixas': {value: null, matchMode: this.filtros.CONTAINS},
        'status': {value: null, matchMode: this.filtros.CONTAINS},
        'diasEmEstoque': {value: null, matchMode: this.filtros.CONTAINS},
        'motivo': {value: null, matchMode: this.filtros.CONTAINS},
        'pedido': {value: null, matchMode: this.filtros.CONTAINS},
      },
    }
  },

  methods: {
    // getClientes () {
    //   ClienteController.getClientesAtivos().requisicao
    //   .then((Response) => {
    //     this.dataClientes = Response.data.data
    //   })
    //   .catch((Error) => {
    //   })
    // },
    
    getProduto(pesquisa) {
    window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.GetProdutoDropDownByPesquisaRepresentanteEmpresa(pesquisa, this.$store.state.representanteSelecionadoId, this.formSearch.UnidadeId).requisicao
        .then((res) => {
          this.ProdutoArray = res.data.data
        })
        .catch(() => {
        })
      }, 1000);
    },

    popularDropDownEmpresa(){
      this.EmpresaArray = this.$store.state.EmpresaArray;
      this.atualizaEmpresaRepresentante()
      },

    limparFiltro(){
      this.formSearch = new FiltroDevolucoes();
      this.devolucoesArray = []
      this.atualizaEmpresaRepresentante()
    },

    buscar(){
      this.pt1 = false
      this.GetDevolucoesByFiltro()
    },

    GetDevolucoesByFiltro(){
      this.$isLoading(true)
      DevolucoesController.GetDevolucoesByFiltro(this.formSearch).requisicao
      .then(res => {
        this.devolucoesArray = res.data.data;
        this.$isLoading(false)
      })
    },

    GetStatusDevolucoes(){
      DevolucoesController.GetStatusDevolucoes()
      .requisicao.then((Response) => {
            this.situacaoArray = Response.data    
            let array = this.situacaoArray.unshift({
              text: 'TODAS',
              value: null
            })
            this.array = array
          })
          .catch(() => {
          });
      },
      
    buscarClientes(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ClienteController.getClienteDropDownsByNome(event, this.formSearch.UnidadeId).requisicao
        .then((response)=> {
          if(!this.formSearch.ClienteId){ // se não tiver cliente selecionado
            this.ClientesArray = response.data.data;
            return;
          }
          this.ClientesArray = this.ClientesArray.concat(response.data.data);
        })
      }, 1000);
    },

    atualizaEmpresaRepresentante(){
      this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId;
    },
  },

  computed: { }

});